import { Fragment } from "react";

export function TextWithLineBreaks({ text }) {
  if (!text) return null;

  return text.split("\n").map((line, index) => (
    <Fragment key={index}>
      {line}
      <br />
    </Fragment>
  ));
}
